import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });
  const [isSending, setIsSending] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [statusType, setStatusType] = useState("");
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSending) return;
    setIsSending(true);
    setStatusMessage("");
    setStatusType("");
    // replace below with your own Service ID, Template ID and Public Key from your EmailJS account
    emailjs
      .sendForm("service_m9oifd5", "template_p2u0vpo", e.target, "YaheiidlCbmv6jD_S")
      .then(
        (result) => {
          alert("Recebemos o seu Email");
          setStatusMessage("Mensagem enviada com sucesso.");
          setStatusType("success");
          clearState();
          setIsSending(false);
        },
        (error) => {
          console.log(error.text);
          alert("Ocorreu um erro ao enviar. Tente novamente.");
          setStatusMessage("Erro ao enviar a mensagem.");
          setStatusType("error");
          setIsSending(false);
        }
      );
  };
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Entre em contato</h2>
                <p>
                  Por favor, preencha o formulário abaixo para nos enviar um e-mail e entraremos em contato com você o 
                  mais breve possível.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Nome"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Mensagem"
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                {statusMessage && (
                  <div className={`alert ${statusType === "success" ? "alert-success" : "alert-danger"}`} role="alert">
                    {statusMessage}
                  </div>
                )}
                <button type="submit" className="btn btn-custom btn-lg" disabled={isSending}>
                  {isSending ? "Enviando..." : "Enviar Mensagem"}
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Informações de Contato</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Endereço
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Telefone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
            <link rel="stylesheet" href="https://cdn.positus.global/production/resources/robbu/whatsapp-button/whatsapp-button.css"/>
            <a id="robbu-whatsapp-button" target="_blank" href="https://api.whatsapp.com/send?phone=5548998333585&text=Ol%C3%A1!%20Quero%20entrar%20em%20contato">
              <div className="rwb-tooltip" style={{ color: "#ffffff", backgroundColor: "#24b96e94",fontWeight: 700 }}>Fale conosco</div>
              <img src="https://cdn.positus.global/production/resources/robbu/whatsapp-button/whatsapp-icon.svg"/>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
